
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 61.48 67.17"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M21.35 67.17a21.35 21.35 0 010-42.7zM40.13 47.91a21.36 21.36 0 000-42.71zM36.45 62.93H25V16.47a57.94 57.94 0 011.08-6.54c.53-1.73 2-5.11 3.84-6.69 2-1.77 4.87-3.93 6.36-3a.75.75 0 01.12.42v.28z"}})])
          )
        }
      }
    